import { observable } from "mobx";
import { OrderedProduct } from "./OrderedProduct";
import { Note } from "./Note";
import { OrderCustomer } from "./OrderCustomer";
import { Status } from "./Status";
import { Supplier } from "./Supplier";

export class Order {
    @observable id: string;
    @observable number: string;
    @observable status: Status;
    @observable ERPOrderReferenceCode: string
    @observable requestedDeliveryDate: string;
    @observable offeredDeliveryDate: string;
    @observable deliverAsSoonAsPossible: boolean;
    @observable products: Array<OrderedProduct>;
    @observable labels: Array<string>;
    @observable notes: Array<Note>;
    @observable customer: OrderCustomer;
    @observable createdByUserID: string;
    @observable isMarkedAsArchived: boolean;
    @observable createdAt: any;
    @observable lastModifiedAt: any;
    @observable version: number;
    @observable supplier: Supplier;

    constructor() {
        this.id = "";
        this.number = "";
        this.status = new Status();
        this.ERPOrderReferenceCode = "";
        this.requestedDeliveryDate = "";
        this.offeredDeliveryDate = "";
        this.deliverAsSoonAsPossible = true;
        this.products = [];
        this.labels = [];
        this.notes = [];
        this.customer = new OrderCustomer();
        this.createdByUserID = "";
        this.isMarkedAsArchived = false;
        this.createdAt = null;
        this.lastModifiedAt = null;
        this.version = 0;
        this.supplier = new Supplier();
    }
}